import React from 'react';
import { CalendarClockIcon, ZoomInIcon } from 'lucide-react';
import { scrollToSection } from '../utils/scrollToSection';
const zoomTips = ['Windows PC: hold Ctrl and press + to zoom in (Ctrl and 0 resets). You can also hold Ctrl and scroll.', 'Mac: hold Cmd (⌘) and press + to zoom in (Cmd and 0 resets).', 'Phone or tablet: pinch two fingers apart on the image to zoom in.'];
export function TopNotices() {
  return <div className="space-y-4" data-id="element-167" data-mp="wnh0vqu3pkbo">
      <section aria-labelledby="notice-zoom-title" className="rounded-xl border border-[#10b981]/25 bg-[#10b981]/[0.06] p-4 sm:p-5" data-id="element-168" data-mp="wkcmk0mx987a">
        <div className="flex gap-3" data-id="element-169" data-mp="mpax13oqi446">
          <ZoomInIcon className="mt-0.5 h-5 w-5 shrink-0 text-[#10b981]" aria-hidden="true" data-id="element-170" data-mp="mqm35a5njnyg" />
          <div className="min-w-0" data-id="element-171" data-mp="2h2alznf08ao4">
            <h2 id="notice-zoom-title" className="font-mono text-[14px] font-semibold tracking-tight text-white" data-id="element-172" data-mp="2h199deicbg4a">
              Clips look small? Zoom in.
            </h2>
            <p className="mt-2 text-[14.5px] leading-relaxed text-white/80" data-id="element-173" data-mp="2bihw7cgp8x2x">
              Some walkthrough clips are detailed. If a GIF or screenshot is hard to read,
              zoom your screen in:
            </p>
            <ul className="mt-3 space-y-2" data-id="element-174" data-mp="21nzqk1rq2rgh">
              {zoomTips.map(tip => <li key={tip} className="flex gap-2.5 text-[14.5px] leading-relaxed text-white/80" data-id="element-175" data-mp="26kyiqertsoc1">
                  <span aria-hidden="true" className="mt-2 h-1 w-1 shrink-0 rounded-full bg-[#10b981]" data-id="element-176" data-mp="2ub2iuc5t25ya" />
                  <span data-id="element-177" data-mp="2zbghx4pfi5k6">{tip}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      <section aria-labelledby="notice-calendar-title" className="rounded-xl border border-[#10b981]/25 bg-[#10b981]/[0.06] p-4 sm:p-5" data-id="element-178" data-mp="2pjaqbw339q5i">
        <div className="flex gap-3" data-id="element-179" data-mp="3d724z6c3qf9y">
          <CalendarClockIcon className="mt-0.5 h-5 w-5 shrink-0 text-[#10b981]" aria-hidden="true" data-id="element-180" data-mp="3hzlloc635qiz" />
          <div className="min-w-0" data-id="element-181" data-mp="3rukf4k8fo23r">
            <h2 id="notice-calendar-title" className="font-mono text-[14px] font-semibold tracking-tight text-white" data-id="element-182" data-mp="3rthomdf0w1od">
              Using Lead Auto-Responders with booking? Do Calendar Sync first.
            </h2>
            <p className="mt-2 text-[14.5px] leading-relaxed text-white/80" data-id="element-183" data-mp="3dv18xwz6n0u3">
              If we&apos;ve turned on automatic replies that book appointments for you,
              connect your calendar (
              <a href="#calendar-sync" onClick={event => {
              event.preventDefault();
              scrollToSection('calendar-sync');
            }} className="font-semibold text-[#10b981] underline decoration-[#10b981]/40 decoration-2 underline-offset-4 transition-colors duration-200 hover:text-[#34d399]" data-id="element-184" data-mp="345hncjk34svj">
                Step 5 — Calendar Sync
              </a>
              ) before anything else. Those booking automations need your calendar connected
              to work correctly.
            </p>
          </div>
        </div>
      </section>
    </div>;
}